module.exports = __webpack_public_path__ + "static/media/aa3.d5a4d527.jpg";